module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/product/google-drive-d884e24c4650dbe648fe3c75bc5eb5a9.svg";